import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { FourOhFour, FilterPrint } from './components'
import {
  App,
  CMSRoute,
  GuidedSearch,
  FilteredSearch,
  ToolDetail
} from './containers'
import withGATracker from './router/withGATracker'


// To reduce amount of strings used throughout app
export const routeNames = {
  root: '/',
  resources: '/resources',
  guidedSearch: '/guided-search',
  filteredSearch: '/filtered-search',
  filterPrint: '/filter-print',
  glossary:'/glossary',
  caseStudies: '/case-studies',
  resourceLibraries: '/resource-libraries',
  dataSources: '/data-sources',
  faq: '/faqs',
  retiredTools: '/retired-tools',
  tool: '/tool/',
  partners: '/partners',
  funding: '/funding',
  contact: '/contact',
  about: '/about',
  privacyPolicy: '/privacy-policy',
}

// React router v4 - https://reacttraining.com/react-router/
// Reference info: https://css-tricks.com/react-router-4/
const appRoutes = (
  <Switch>
    <CMSRoute path={routeNames.root} exact contentKey="home" />
    <CMSRoute path={routeNames.resources} exact contentKey="resources" bgClassName="topography-bg-6" />
    <CMSRoute path={routeNames.resources + routeNames.glossary} contentKey="glossary" bgClassName="topography-bg-3" />
    <CMSRoute path={routeNames.resources + routeNames.caseStudies} contentKey="case-studies" bgClassName="topography-bg-7" />
    <CMSRoute path={routeNames.resources + routeNames.resourceLibraries} contentKey="resource-libraries" bgClassName="topography-bg-8" />
    <CMSRoute path={routeNames.resources + routeNames.dataSources} contentKey="data-sources" bgClassName="topography-bg-9" />
    <CMSRoute path={routeNames.resources + routeNames.faq} contentKey="faqs" bgClassName="topography-bg-10" />
    <CMSRoute path={routeNames.resources + routeNames.retiredTools} contentKey="retired-tools" bgClassName="topography-bg-11" />
    <CMSRoute path={routeNames.about} contentKey="about" bgClassName="topography-bg-1" />
    <CMSRoute path={routeNames.partners} contentKey="partners" bgClassName="topography-bg-4" />
    <CMSRoute path={routeNames.funding} contentKey="funding" bgClassName="topography-bg-5" />
    <CMSRoute path={routeNames.contact} contentKey="contact" bgClassName="topography-bg-2" />
    <CMSRoute path={routeNames.privacyPolicy} contentKey="privacy-policy" bgClassName="topography-bg-1" />
    <Route path={routeNames.guidedSearch} exact component={GuidedSearch} />
    <Route path={routeNames.filteredSearch} exact component={FilteredSearch} />
    <Route path={`${routeNames.tool}:slug`} component={ToolDetail} />
    <Route component={FourOhFour} />
  </Switch>
)

const baseRoute = (
  <Switch>
    <Route path={routeNames.filterPrint} exact component={FilterPrint} />
    <Route
      path={routeNames.root}
      render={withGATracker(props => <App {...props}>{appRoutes}</App>)}
    />
  </Switch>
)

export default baseRoute
